//
//
//
//
//
//
//
//
//
import { Hero, Navigation } from '~/components/landing-page-1';
export default {
  name: 'LandingPageHeader',
  components: {
    Hero,
    Navigation
  }
};